export const SIZES_FROM_WIDGET = {
    xsmall: { icon: 'xsmall', ratingNumber: 'bs', reviewNumber: 'bs' },
    small: { icon: 'small', ratingNumber: 'bm', reviewNumber: 'bm' },
    medium: { icon: 'small', ratingNumber: 'bl', reviewNumber: 'bs' },
};
